import styled from 'styled-components';
import { Element, Section } from 'src/constants/footfall';
import UserLink from 'src/modules/shared/links/userLink';
import Badge from 'src/components/badge';
import MemberTags from 'src/components/memberTags';
import CommunityMemberCardMenu from 'src/modules/community/communityMembers/communityMemberCardMenu';
import { Bio } from 'src/components/memberCard';
import { Size } from 'src/components/avatar';
import { titleSmall } from 'styles-js/mixins/typography';
import { CommunityMember } from 'src/constants/types';
import MemberCardInfo from 'src/components/memberCardInfo';
type Props = {
  member: CommunityMember;
  isOnTwoColumns?: boolean;
  onMemberCardClick?: (username: string) => void;
};
export default function CommunityMemberCard({
  isOnTwoColumns = false,
  member,
  onMemberCardClick = () => {}
}: Props): JSX.Element {
  const {
    age,
    bio,
    country,
    gender,
    healthInterests,
    profileImageSmall2x,
    roles,
    username
  } = member;
  const parsedBio = bio?.replace(/[\b\t\n\f\r]/g, ' ')?.trim();
  return <Wrapper className={isOnTwoColumns ? 'base-card-wider' : 'base-card'} data-sentry-element="Wrapper" data-sentry-component="CommunityMemberCard" data-sentry-source-file="communityMemberCard.tsx">
      <div className="base-card__inner community-member-card__inner" data-testid="base-card-inner">
        <div className="community-member-card__header">
          <UserLink avatarSize={Size.Medium} className="community-member-card__avatar" signupContext={{
          element: Element.Avatar,
          section: Section.CommunityMembers
        }} user={{
          username,
          profileImageSmall: profileImageSmall2x
        }} onClick={() => onMemberCardClick(username)} data-sentry-element="UserLink" data-sentry-source-file="communityMemberCard.tsx" />

          <div className="community-member-card__username">
            <UserLink className="community-member-card__user-link" signupContext={{
            element: Element.UserLink,
            section: Section.CommunityMembers
          }} user={{
            username
          }} onClick={() => onMemberCardClick(username)} data-sentry-element="UserLink" data-sentry-source-file="communityMemberCard.tsx" />
            {roles?.length > 0 && <StyledBadge>{roles[0]}</StyledBadge>}
          </div>

          <CommunityMemberCardMenu member={member} data-sentry-element="CommunityMemberCardMenu" data-sentry-source-file="communityMemberCard.tsx" />
        </div>

        <MemberCardInfo age={age} country={country} gender={gender} data-sentry-element="MemberCardInfo" data-sentry-source-file="communityMemberCard.tsx" />

        <Bio data-sentry-element="Bio" data-sentry-source-file="communityMemberCard.tsx">{parsedBio}</Bio>

        {healthInterests?.length > 0 && <MemberTags tags={healthInterests} username={username} />}
      </div>
    </Wrapper>;
}
const Wrapper = styled.div`
  .community-member-card__inner {
    min-height: 224px;
    height: 100%;
    padding: 15px;
    display: flex;
    flex-direction: column;
    border: ${({
  theme
}) => theme.greyLine};
    box-shadow: none;

    @media (${({
  theme
}) => theme.underScreenXsmall}) {
      min-height: 0;
    }
  }

  .community-member-card__header {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
  }

  .community-member-card__avatar {
    margin-right: 10px;

    img {
      width: 40px;
      height: 40px;
    }
  }

  .community-member-card__username {
    flex-grow: 2;
  }

  .community-member-card__user-link {
    ${titleSmall}
    display: block;
    word-break: break-word;
    transition: all 0.5s ease;
    &:hover, &:focus, &:active {
      color: ${props => props.theme.colorGreyDark};
    }
  }
`;
const StyledBadge = styled(Badge)`
  display: inline-block;
  margin-top: 4px;
`;